import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { IUser } from '@app/core/interfaces';
import { ApiService } from '@app/core/services';

import { BehaviorSubject } from 'rxjs';
import { AUTH_TOKEN, AUTH_USER, LOGIN_TOKEN, TOKEN_ROUTE } from '../interfaces/app-data.model';
import { TokenService } from '../modules/authentication/token.service';

@Injectable({
    providedIn: 'root'
})
export class UserService {
    private readonly _user = new BehaviorSubject<IUser | null>(null);
    readonly user$ = this._user.asObservable();

    constructor(private router: Router, private apiService: ApiService, private tokenService: TokenService) {}

    public checkAndSetIfAuthenticated() {
        const userCopy = this._user.getValue();
        if (userCopy && userCopy != null) {
            return;
        }

        // If we have the token and user already stored then we're already
        const token = localStorage.getItem(AUTH_TOKEN);
        const user = localStorage.getItem(AUTH_USER);
        const loginToken = localStorage.getItem(LOGIN_TOKEN);

        if (token && token !== null && user && user !== null) {
            this._user.next(JSON.parse(user));

            this.router.navigate(['/share']);
        }
        // TODO: Check if Chrome auth is complete here
        else if (loginToken && loginToken !== null) {
            this.apiService.post(TOKEN_ROUTE, { email: loginToken }).subscribe((user?: IUser) => {
                if (user) {
                    this.tokenService.saveTokenInLocalStorage(AUTH_TOKEN, user.token);
                    this.tokenService.saveTokenInLocalStorage(AUTH_USER, JSON.stringify(user));
                    this._user.next(user);
                    this.router.navigate(['/share']);
                }
            });
        }
    }

    get user() {
        return this._user.getValue();
    }

    set user(user: IUser) {
        this._user.next(user);
    }

    public isAuthenticated() {
        return !!this._user.getValue();
    }
}
